import React from 'react';

/* eslint-disable max-len */
const SignInIcon = () => (
  <svg className="bb-signin-icon" viewBox="0 0 65.2 98.81"><path d="M60.83,39.48H58.12V24.75C58.12,11.43,46.85.59,33,.59S7.88,11.43,7.88,24.75a4.77,4.77,0,0,0,9.54,0c0-8.06,7-14.62,15.58-14.62s15.58,6.56,15.58,14.62V39.48H5.17A4.77,4.77,0,0,0,.4,44.25V67.47A32,32,0,0,0,32.33,99.41h1.34A31.94,31.94,0,0,0,65.6,67.47V44.25A4.77,4.77,0,0,0,60.83,39.48ZM56.06,49V67.47a22.4,22.4,0,0,1-22.4,22.4H32.33A22.42,22.42,0,0,1,9.94,67.47V49Z" transform="translate(-0.4 -0.59)"/><path d="M33,56.33a4.77,4.77,0,0,0-4.77,4.77v14a4.77,4.77,0,0,0,9.54,0v-14A4.77,4.77,0,0,0,33,56.33Z" transform="translate(-0.4 -0.59)"/></svg>
);

export default SignInIcon;
